import { useInView } from '../../hooks/useInView';
import { TrendingUp, Flame, Leaf, Heart } from 'lucide-react';

const benefits = [
  {
    icon: TrendingUp,
    title: 'Increase Semen Volume',
    desc: 'Formulated with botanical extracts clinically associated with supporting seminal fluid production and quality.',
  },
  {
    icon: Flame,
    title: 'Support Libido',
    desc: 'Natural compounds like Catuaba Bark and Korean Ginseng have been used for centuries to ignite male drive.',
  },
  {
    icon: Heart,
    title: 'Enhance Reproductive Health',
    desc: 'A comprehensive blend targeting male reproductive system function, hormonal balance, and cellular health.',
  },
  {
    icon: Leaf,
    title: 'Natural Botanical Formula',
    desc: 'Free from synthetic compounds. Every capsule is packed with premium plant-based ingredients you can trust.',
  },
];

export default function BenefitsSection() {
  const [ref, inView] = useInView(0.1);

  return (
    <section
      id="benefits"
      data-testid="benefits-section"
      style={{ backgroundColor: '#F7F7F5', padding: '96px 0' }}
    >
      <div ref={ref} className="max-w-7xl mx-auto px-6 md:px-12">
        <div className={`text-center mb-14 fade-up ${inView ? 'visible' : ''}`}>
          <span className="overline block mb-4">What It Does</span>
          <h2 style={{
            fontFamily: 'Outfit, sans-serif',
            fontWeight: 800,
            fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
            color: '#0D1A2E',
            letterSpacing: '-0.025em',
          }}>
            Designed for Male Reproductive Performance
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {benefits.map((b, i) => (
            <div
              key={b.title}
              data-testid={`benefit-card-${i}`}
              className={`card-light card-hover rounded-2xl p-7 fade-up delay-${i + 1} ${inView ? 'visible' : ''}`}
            >
              <div className="icon-bg-blue mb-5">
                <b.icon size={20} style={{ color: '#1B3D7E' }} strokeWidth={1.5} />
              </div>
              <h3 style={{
                fontFamily: 'Outfit, sans-serif',
                fontSize: '1rem',
                fontWeight: 700,
                color: '#0D1A2E',
                marginBottom: '10px',
                lineHeight: 1.3,
              }}>
                {b.title}
              </h3>
              <p style={{
                fontFamily: 'Manrope, sans-serif',
                fontSize: '0.85rem',
                color: '#64748B',
                lineHeight: 1.75,
              }}>
                {b.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
